import { useEffect, useState } from 'react';

const MS_IN_SECOND = 1000;

const getElapsedSeconds = (accumulatedSeconds: number, sessionStartedAt: number): number =>
   accumulatedSeconds + Math.floor((Date.now() - sessionStartedAt) / MS_IN_SECOND);

export const useTickingElapsedSeconds = (accumulatedSeconds: number, sessionStartedAt: number): number => {
   const [elapsedSeconds, setElapsedSeconds] = useState(() => getElapsedSeconds(accumulatedSeconds, sessionStartedAt));

   useEffect(() => {
      setElapsedSeconds(getElapsedSeconds(accumulatedSeconds, sessionStartedAt));

      const intervalId = setInterval(() => {
         setElapsedSeconds(getElapsedSeconds(accumulatedSeconds, sessionStartedAt));
      }, MS_IN_SECOND);

      return () => clearInterval(intervalId);
   }, [accumulatedSeconds, sessionStartedAt]);

   return elapsedSeconds;
};
